// extracted by mini-css-extract-plugin
export default {"root":"styles_root__wfXN9","woList":"styles_woList__aVVhT"};